import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { BsLink } from '@hotelplan/core.basis.bs-link';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { NavigationIds } from 'components/domain/geo/navigation/GeoNavigation.types';
import { handleNavigationClick } from 'components/domain/geo/navigation/GeoNavigation.utils';
import { LayoutContext } from 'components/domain/layout/Layout.context';

const Link = styled(BsLink)(({ theme }) => theme.link.uiPrimary);

type TProps = { text: string; withShowMore?: boolean };

const FdrGeoInformationSectionLeadText: React.FC<TProps> = ({
  text,
  withShowMore,
}: TProps) => {
  const [t] = useTranslation('geo');
  const { headerHeight } = useContext(LayoutContext);
  const { mobile } = useDeviceType();

  return (
    <>
      <span dangerouslySetInnerHTML={{ __html: text }} className="lead-text" />{' '}
      {withShowMore ? (
        <Link
          onClick={() => {
            handleNavigationClick(
              NavigationIds.LONG_TEXT,
              headerHeight,
              mobile
            );
          }}
        >
          <span className="link-text">{t('geo:show.more.information')}</span>
        </Link>
      ) : null}
    </>
  );
};

export default FdrGeoInformationSectionLeadText;
